// This is available in Lodash but importing it just for this is annoying
// Return an object type (took that from Lodash's implementation)
import lodash from "lodash";

export function isObject(value: unknown): value is object {
  return typeof value === "object" && value !== null;
}

// https://stackoverflow.com/a/25334280
export function objectDeepMap(obj: {}, callback: (value: unknown) => unknown) {
  return lodash.transform(obj, function(result, val, key) {
    if (lodash.isObject(val)) {
      // @ts-ignore
      result[key] = objectDeepMap(val, callback);
    } else {
      // @ts-ignore
      result[key] = callback(val, key, obj);
    }
  });
}

// https://stackoverflow.com/questions/5072136/javascript-filter-for-objects/37616104#37616104
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function filterObject<T>(obj: T, predicate: (item: any) => boolean): T {
  return (
    Object.keys(obj)
      // @ts-ignore
      .filter(key => predicate(obj[key]))
      // @ts-ignore
      .reduce((res, key) => ((res[key] = obj[key]), res), {}) as T
  );
}
